import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { OpportunityUserView, SearchUsersParameters } from '@api-proxies';
import { UserService } from '@http/clients/user.service';
import { OpportunityUser } from '@models/OpportunityUser';
import { EditorComponentBase, GenericTypeAheadMultiselectComponent, ObjectExtensionsService } from 'ngx-lib';
import { CustomMenuItemComponent } from '../../custom-menu-item/custom-menu-item.component';
import { ValidationErrorMessageComponent } from '../../validation-error-message/validation-error-message.component';

@Component({
    selector: 'app-opportunity-user-editor',
    templateUrl: './opportunity-user-editor.component.html',
    styleUrls: ['./opportunity-user-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadMultiselectComponent, ValidationErrorMessageComponent, CustomMenuItemComponent]
})
export class OpportunityUserEditorComponent extends EditorComponentBase<OpportunityUserView[]> implements OnInit {
    userItems?: OpportunityUser[];

    selectedUsers?: OpportunityUser[];

    constructor(
        private readonly userService: UserService,
        private readonly objectExtensionService: ObjectExtensionsService
    ) {
        super();
    }

    ngOnInit(): void {
        if (this.bindingProperty) {
            const mappedResults = this.bindingProperty.map((x) => OpportunityUser.fromInterface(x));
            this.selectedUsers = mappedResults?.filter((user) => user.userExternalId);
        }
    }

    async onUserTextChange(event: string) {
        const results = await this.userService?.search({
            filterText: event,
            isActive: true
        } as SearchUsersParameters);

        this.userItems = results.map((x) => OpportunityUser.fromUserView(x));
    }

    onSelectedUserChange(event: OpportunityUser[]) {
        this.bindingProperty = this.objectExtensionService.clone(event) as OpportunityUser[];
        this.valueChange.emit();
        this.validate();
    }
}
